module.exports = __webpack_public_path__ + "img/rose_curve.1a92c961.png";